"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import styles from "./CookieBanner.module.css";

const CONSENT_KEY = "flare_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const stored = window.localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      setVisible(true);
    }

    const openPreferences = () => {
      setVisible(true);
    };

    window.addEventListener("flare-cookie-preferences", openPreferences);
    return () => {
      window.removeEventListener("flare-cookie-preferences", openPreferences);
    };
  }, []);

  const setConsent = (value) => {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(CONSENT_KEY, value);
    window.dispatchEvent(new Event("flare-cookie-consent"));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className={styles.content}>
        <div className={styles.text}>
          <strong>Cookies &amp; Analytics</strong>
          <span>
            We use essential cookies to run the service and optional analytics cookies to improve Flare.{" "}
            <Link href="/cookies" className={styles.link}>
              Learn more
            </Link>
            .
          </span>
        </div>
        <div className={styles.actions}>
          <button type="button" className={styles.secondary} onClick={() => setConsent("rejected")}>
            Reject
          </button>
          <button type="button" className={styles.primary} onClick={() => setConsent("accepted")}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
